// extracted by mini-css-extract-plugin
module.exports = {"expandable":"Expandable_expandable__Lx72a","legacy":"Expandable_legacy__yPjFb"};